let Monitoring = {
    timers: {},
    startActivity(name) {
        this.timers[name] = performance.now();
    },
    endActivity(name) {
        if (this.timers.hasOwnProperty(name)) {
            let timeElapsed = performance.now() - this.timers[name];
            console.log(`${name} completed. Time elapsed: ${timeElapsed}ms`);
            delete this.timers[name];
        }
    }
}

export default Monitoring;